<template>
  <div class="avain_application_simpleModalContainer" ref="avain_application_simpleModalContainer">
    <div class="avain_application_simpleModalContent">
      <form @submit.prevent="handleSubmit">
        <slot/>
        <div class="avain_application_simpleModalButtons">
          <button @click="handleCancel" type="button" :class="`avain_application_simpleModalCancelButton btn btn--large btn--outline ${customPrimaryButtonClass} mr-2`">
            {{ cancelButtonText}}
          </button>
          <button :disabled="submitDisabled" type="submit" :class="`avain_application_simpleModalPrimaryButton btn btn--large ${customPrimaryButtonClass}`">
            {{ primaryButtonText}}
          </button>
        </div>
      </form>
      <div class="avain_application_simpleModalErrorAlert" v-if="hasError">
        {{ errorMessage }}
      </div>
      <div class="avain_application_simpleModalLoadingOverlay" v-if="isLoading">
        <div class="avain_application_simpleModalLoadingOverlayContent">
          <LoadSpinner style="margin-top: 25%;" />
          {{ loadingText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadSpinner from "./LoadSpinner"

/**
 * This is a simple modal component that is not attached in any way to the Vuex state or other globally bound variables.
 */
export default {
  components: {
    LoadSpinner,
  },
  props: {
    primaryButtonText: {
      type: String,
      default: "Lähetä"
    },
    cancelButtonText: {
      type: String,
      default: "Peruuta"
    },
    errorMessage: {
      type: String,
      required: false
    },
    loadingText: {
      type: String,
      required: false
    },
    customPrimaryButtonClass: {
      type: String
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    handleCancel: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    submitDisabled: {
      type: Boolean,
      default: false
    },
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.mr-2 {
  margin-right: 16px;
}

.avain_application_simpleModalContainer {
  position: fixed;
  background: rgba(0,0,0,.75);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 111111;
  overflow: auto;

  .avain_application_simpleModalLoadingOverlay {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    background: rgba(255,255,255,.88);

    .avain_application_simpleModalLoadingOverlayContent {
      text-align: center;
    }
  }

  .avain_application_simpleModalButtons {
    text-align: left;
  }

  .avain_application_simpleModalErrorAlert {
    background: #ff1515;
    color: white;
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 20%);
    display: block;
    padding: 8px 12px;
    border-radius: 3px;
    margin-top: 16px;
    font-weight: bold;
    letter-spacing: 0.25px;
  }

  .avain_application_simpleModalContent {
    background: #fff;
    border-radius: 3px;
    position: absolute;
    top: 25%;
    transform: translateY(-25%);
    width: 550px;
    max-width: 95%;
    margin: 0 auto 24px;
    left: 0;
    right: 0;
    padding: 24px;

    @media (max-width: 600px) {
      top: 24px;
      transform: none;
      padding: 16px;
    }

    h2, h3, h4, h5 {
      font-weight: bold;
    }

    h2, h3, h4, h5, p {
      margin-bottom: 16px;
    }

    label {
      font-weight: bold;
      letter-spacing: 0.25px;
    }

    input {
      width: 100%;
      display: block;
      margin-bottom: 16px;
      padding: 8px 12px;
      height: 44px;
      font-size: 15px;
      background: #eee;
      border: 0;
      border-bottom: 1px solid rgba(0,0,0,.7);
    }
  }
}
</style>
